<template>
<v-app class="survey-container">

    <v-layout class="bg-light-blue" row wrap>
      <v-flex xs12>
        <NavBarHome></NavBarHome>

        <div class="content">
          <h1>Page Unavailable</h1>

          <p class="content-detail">
            This function is not available during the Pretest.  Click "Back" to return to the Homepage.
          </p>

          <br/>

          <v-btn normal class="blue-button" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
            Back</v-btn>

        </div>
      </v-flex>
    </v-layout>

    <Footer></Footer>

</v-app>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import { NavBarHome } from '@/components/NavBarHome.vue';
export default {
  name: 'Unavailable',
  props: {
  },
  data: () => ({
    prevRoute: null
  }),
  watch: {
  },
  mounted () {
  },
  methods: {
    // WIP - really want this to go back up one level or back to home page only when one level down (TODO)
    back () {
      this.$router.push({ name: 'landing' });
    }
  },
  computed: {
  }
}
</script>

<style scoped>
.survey-container  {
  width: 100%;
  margin: 0 auto;
}
.content {
  padding: 3% 3% 3% 5%;
  text-align: left;
}
.content-header {
  font-weight: bold;
}
.content-detail {
  font-weight: normal;
}
.v-text-field >>> input {
  text-align: left;
  padding: 3px;
  min-width: 150px;
}
h1 {
  margin: 20px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-size: 20pt;
  font-style: normal;
  font-weight: bold;
}
h2 {
  font-size: 16pt;
  font-weight: normal;
}
h3 {
  font-size: 14pt;
  font-weight: normal;
  color: #c55911;
}
a {
  font-weight: bold;
}
</style>
